export default "__VITE_ASSET__f9381410__"